module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("會員條款")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("會員條款")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("隱私權政策")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "/member_policy"
    }
  }, [_vm._v("會員條款")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('h3', {
    staticClass: "title hidden-xs hidden-sm"
  }, [_vm._v("會員條款")]), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_c('p', [_vm._v("\n                      愛幫您股份有限公司之會員，以下簡稱 i80 會員， i80 會員享有各合作商家經營的商品及服務優惠，及經營組織會員之權利，以下為不同會員級別的權利與義務\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                      一、一般會員："), _c('br'), _vm._v("\n                      1、免費註冊享終身折扣優惠並回饋 12 ％ 點數"), _c('br'), _vm._v("\n                      2、會員取得之點數僅供愛幫您股份有限公司平台內使用\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                      二、分享會員："), _c('br'), _vm._v("\n                      １、必須符合會員身分。"), _c('br'), _vm._v("\n                      ２、必須參加經營者會員培訓。"), _c('br'), _vm._v("\n                      ３、組織回饋的 50％ 產品，50 ％點數，個人必須有消費方可領取點數。"), _c('br'), _vm._v("\n                      ４、每月必須達，消費 500 點以上(因消費結算方式有點數上的落差，請至 -> 回饋金查詢 -> 總點數，計算結果為準)，才能具有維持經營組織權，若未達消費門檻，原本推薦組織將不再列入您的會員帳號下。"), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                      三、以上會員資格公司保有修改條款權利\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                      四、一般會員以及分享會員，若違反愛幫您之規定或影響公司商譽等，愛幫您股份有限公司有權立即停止該帳戶、組織以及福利。\n                    ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f27043a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MemberPolicy.vue
// module id = 315
// module chunks = 1